import Entity from './entity'
export default class Data extends Entity<number>{
    Path:string;
}